import axios from 'axios';
import CONSTANTS from '../utils/constants';

const getConfig = async (): Promise<{ backendApiUrl: string; }> => {
  const currentUrl = window.location.origin;

  if (currentUrl === CONSTANTS.PROD_URL) {
    return {
      backendApiUrl: 'https://public.commerce.payone.com',
    };
  } else {
    try {
      const response = await axios.get('/config.json');
      const data = await response.data;

      if (!data?.backendApiUrl) {
        throw new Error("Missing 'backendApiUrl' in config.json");
      }
  
      return {
        backendApiUrl: data.backendApiUrl,
      };
    } catch (error) {
      console.error("Failed to load 'config.json'", error);
      throw error;
    }

  }
};

const config = await getConfig();

const axiosInstance = axios.create({
  baseURL: config.backendApiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 5000,
});

export default axiosInstance;